import {
  capabilityNavItems,
  industryNavItems,
  type SectionNavItem,
} from "@/content/navigationCatalog";
import { routes } from "./routes";

/** A page under a section, as its menu lists it: title, line, mark and colour. */
export type SectionPage = SectionNavItem;

// Sub-pages for the sections that open a menu, read from the same content
// records the Capabilities and Industries pages render: the header never
// authors its own copy of them.
export const sectionPages: Readonly<Record<string, readonly SectionPage[]>> = {
  [routes.capabilities.index]: capabilityNavItems,
  [routes.industries.index]: industryNavItems,
};

export const isActive = (href: string, pathname: string) =>
  pathname === href || pathname.startsWith(`${href}/`);
